// See this slack thread for the calculation of these factors
// https://gesagt-getan.slack.com/archives/CNGS4G5R8/p1680259457358189?thread_ts=1679480139.694819&cid=CNGS4G5R8
const FACTORS = {
    6: 1.0054549646,
    12: 1.0101248324,
    24: 1.0401585988,
    36: 1.0753638226,
    48: 1.1212714959,
    60: 1.1524189933
};
const MINIMAL_VALUE = 1500;

const NAMESPACE = 'finance-calculator';
let trackingTimeout;

testIMask();

function testIMask() {
    if (typeof window.IMask == 'function') {
        init();
    } else {
        setTimeout(testIMask, 50);
    }
}

function init() {
    [...document.querySelectorAll(`.${NAMESPACE}`)].forEach(calculator => {
        const INPUT = calculator.querySelector('input');
        const MASK = window.IMask(INPUT, {
            mask: '€ NUM',
            blocks: {
                NUM: {
                    mask: Number,
                    signed: false,
                    scale: 0,
                    thousandsSeparator: '.'
                }
            }
        });
        const totalTargets = [...calculator.querySelectorAll(`.${NAMESPACE}__total-target`)];
        let targets = [];
        [...calculator.querySelectorAll(`.${NAMESPACE}__target`)].forEach(element => {
            let data = element.dataset;
            targets[targets.length] = {
                element,
                totalElement: totalTargets[targets.length],
                // apr: data.apr,
                months: data.months,
                // years: data.months / 12,
                factor: FACTORS[data.months] / data.months
            };
        });
        MASK.on('accept', () => {
            let typedValue = parseInt(MASK.unmaskedValue);
            if (typedValue >= MINIMAL_VALUE) {
                targets.forEach(target => {
                    // Real calulation
                    // const SUM = typedValue * Math.pow(target.apr / 100 + 1, target.years);
                    // const MONTHLY_RATE = SUM / target.months;
                    const MONTHLY_RATE = typedValue * target.factor;
                    const roundedMonthlyRate = Math.ceil(MONTHLY_RATE);
                    target.element.innerHTML = `€ ${roundedMonthlyRate.toLocaleString()},–`;
                    if (target.totalElement) {
                        target.totalElement.innerHTML = `€ ${(roundedMonthlyRate * target.months).toLocaleString()},–`;
                    }
                });
                if (trackingTimeout) {
                    clearTimeout(trackingTimeout);
                }
                trackingTimeout = setTimeout(() => {
                    window.trackingEvent('calculator', {calculatorAmount: typedValue});
                }, 1000);
            } else {
                targets.forEach(target => {
                    target.element.innerHTML = '';
                    target.totalElement.innerHTML = '';
                });
            }
        });
    });
}
